import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroupMUI from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import { ReactElement, ReactNode } from 'react';

import { AllocationMode, allocationModeOptions } from '../../../constants/allocationMode';
import { useEditClientAllocationContext } from '../../../EditClientAllocation/context/EditClientAllocationContext';

import styles from './EditAllocationFormLayout.module.scss';

interface IProps {
  title: string;
  isRestored: boolean;
  children: ReactNode;
}

const EditAllocationFormLayout = ({ title, isRestored, children }: IProps): ReactElement => {
  const { allocationMode, setAllocationMode, showAllocationModeRadio } =
    useEditClientAllocationContext();

  return (
    <Paper>
      <div className={styles.wrapper}>
        <Grid container spacing={4}>
          <Grid item sm={12} className={styles.titleRow}>
            <Typography variant="subtitle1" className={styles.assignedClientsTitle}>
              {title}
            </Typography>
            {showAllocationModeRadio && (
              <RadioGroupMUI
                row
                value={allocationMode}
                onChange={(_, value) => setAllocationMode(value as AllocationMode)}
              >
                {allocationModeOptions.map(option => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    control={<Radio color="primary" size="small" />}
                  />
                ))}
              </RadioGroupMUI>
            )}
          </Grid>
        </Grid>

        {isRestored && <div className={styles.formWrapper}>{children}</div>}
      </div>
    </Paper>
  );
};

export default EditAllocationFormLayout;
